enum ApiUrl {
  InvestmentSubmit = "/www/home/customer_message",
}

export default ApiUrl;
